module.exports = __webpack_public_path__ + "static/media/D_A.4766a1cd.png";